(function () {
  var API_BASE = 'https://wishlist.shopsdata.store';
  var SHOP_DOMAIN = window.__SHOP_DOMAIN__ || ''; // 部署后替换为真实地址

  // ─── 统计：愿望清单页加购事件 ─────────────────────────────
  // 走 wishlist 服务端转发，避免浏览器跨域 CORS 导致只发出 preflight
  var TRACK_ENDPOINT = 'https://wishlist.shopsdata.store/api/track';
  // 若未注入 window.__STORE_ID__，先回退到当前店铺固定值（避免统计接口丢弃空 store_id）
  var STORE_ID = window.__STORE_ID__ || '0ebaf504-4761-4037-ae82-d582c927738e';

  function getSessionId() {
    var sid = window.localStorage.getItem('session_id');
    if (!sid) {
      sid = Math.random().toString(36).slice(2);
      window.localStorage.setItem('session_id', sid);
    }
    return sid;
  }

  function reportShopifyEvent(eventName, eventData) {
    try {
      var payload = {
        event: eventName,
        timestamp: new Date().toISOString(),
        store_id: STORE_ID,
        session_id: getSessionId(),
        user_id: '',
        url: window.location.href,
        referrer: document.referrer,
        user_agent: navigator.userAgent,
        data: eventData || {},
      };

      fetch(TRACK_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true,
        mode: 'cors',
        credentials: 'omit',
      }).catch(function () {});
    } catch (e) {}
  }

  document.addEventListener('DOMContentLoaded', function () {
    var container = document.getElementById('WishlistPageList');
    var restoreSection = document.getElementById('WishlistRestore');
    var restoreInput = document.getElementById('WishlistRestoreEmail');
    var restoreBtn = document.getElementById('WishlistRestoreBtn');
    var restoreMsg = document.getElementById('WishlistRestoreMsg');

    if (!container || !window.Wishlist) return;

    // ─── 判断是否已有 token（URL 或 localStorage）──────────
    function getTokenFromUrl() {
      var params = new URLSearchParams(window.location.search);
      return params.get('token') || null;
    }

    function initPage() {
      var urlToken = getTokenFromUrl();
      var localToken = window.Wishlist.getToken();
      var token = urlToken || localToken;

      if (urlToken && urlToken !== localToken) {
        // URL 带来了新 token，保存到 localStorage
        window.Wishlist.setToken(urlToken);
        token = urlToken;
      }

      if (token) {
        // 有 token → 从服务端加载，然后渲染
        hideRestoreSection();
        window.Wishlist.loadFromServer(token, SHOP_DOMAIN).then(function () {
          render();
        });
        // 确保 URL 有 token 参数
        updateUrlToken(token);
      } else {
        // 无 token → 先渲染本地数据，同时显示恢复输入框
        render();
        showRestoreSection();
      }
    }

    function updateUrlToken(token) {
      var url = new URL(window.location.href);
      if (url.searchParams.get('token') !== token) {
        url.searchParams.set('token', token);
        window.history.replaceState({}, '', url.toString());
      }
    }

    function showRestoreSection() {
      if (restoreSection) restoreSection.style.display = '';
    }

    function hideRestoreSection() {
      if (restoreSection) restoreSection.style.display = 'none';
    }

    // ─── 邮箱恢复按钮 ──────────────────────────────────────
    if (restoreBtn && restoreInput) {
      restoreBtn.addEventListener('click', function () {
        var email = restoreInput.value.trim();
        if (!email || !email.includes('@')) {
          showRestoreMsg('请输入有效的邮箱地址', 'error');
          return;
        }

        restoreBtn.disabled = true;
        restoreBtn.textContent = '恢复中...';

        window.Wishlist.registerEmail(email).then(function (token) {
          restoreBtn.disabled = false;
          restoreBtn.textContent = '恢复收藏';

          if (!token) {
            showRestoreMsg('未找到该邮箱的收藏记录', 'error');
            return;
          }

          updateUrlToken(token);
          hideRestoreSection();

          window.Wishlist.loadFromServer(token, SHOP_DOMAIN).then(function () {
            var items = window.Wishlist.list();
            if (items.length === 0) {
              showRestoreMsg('该邮箱暂无收藏记录', 'info');
              showRestoreSection();
            } else {
              render();
            }
          });
        });
      });

      // 回车触发
      restoreInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') restoreBtn.click();
      });
    }

    function showRestoreMsg(text, type) {
      if (!restoreMsg) return;
      restoreMsg.textContent = text;
      restoreMsg.className = 'wishlist-page__restore-msg wishlist-page__restore-msg--' + type;
      restoreMsg.style.display = '';
    }

    // ─── 渲染收藏列表 ──────────────────────────────────────
    function renderEmpty() {
      container.innerHTML = '';
      var empty = document.createElement('p');
      empty.className = 'wishlist-page__empty';
      empty.textContent = container.dataset.emptyText || '你的愿望清单还是空的～';
      container.appendChild(empty);
    }

    async function render() {
      var items = window.Wishlist.list();
      if (!items.length) {
        renderEmpty();
        return;
      }

      container.innerHTML = '';

      var promises = items.map(function (item) {
        if (!item.productHandle) return Promise.resolve({ item: item, product: null });
        return fetch('/products/' + encodeURIComponent(item.productHandle) + '.js')
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(function (product) { return { item: item, product: product }; })
          .catch(function () { return { item: item, product: null }; });
      });

      var results = await Promise.all(promises);

      results.forEach(function (result) {
        var item = result.item;
        var product = result.product;
        var card = buildCard(item, product);
        container.appendChild(card);
      });
    }

    function buildCard(item, product) {
      var card = document.createElement('article');
      card.className = 'wishlist-page__card';

      // 关闭按钮
      var closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'wishlist-page__remove';
      closeBtn.dataset.action = 'remove';
      closeBtn.dataset.variantId = item.variantId;
      closeBtn.innerHTML = '&times;';
      card.appendChild(closeBtn);

      // 图片
      if (product && product.images && product.images[0]) {
        var imgLink = document.createElement('a');
        imgLink.href = product.url || '/products/' + item.productHandle;
        imgLink.className = 'wishlist-page__image-link';
        var img = document.createElement('img');
        img.src = product.images[0];
        img.alt = product.title || '';
        img.className = 'wishlist-page__image';
        imgLink.appendChild(img);
        card.appendChild(imgLink);
      }

      // 信息区
      var info = document.createElement('div');
      info.className = 'wishlist-page__info';

      var titleLink = document.createElement('a');
      titleLink.className = 'wishlist-page__item-title';
      titleLink.href = (product && product.url) || (item.productHandle ? '/products/' + item.productHandle : '#');
      titleLink.textContent = (product && product.title) || item.productTitle || '商品 #' + item.productId;
      info.appendChild(titleLink);

      var price = document.createElement('div');
      price.className = 'wishlist-page__price';
      if (product && product.price) {
        price.textContent = (product.price / 100).toFixed(2);
      }
      info.appendChild(price);
      card.appendChild(info);

      // 表单
      var form = document.createElement('form');
      form.className = 'wishlist-page__form';
      form.method = 'post';
      form.action = (product && product.url) || (item.productHandle ? '/products/' + item.productHandle : '#');

      var idInput = document.createElement('input');
      idInput.type = 'hidden';
      idInput.name = 'id';
      idInput.value = item.variantId || '';
      form.appendChild(idInput);

      // 单选项变体下拉
      var requiresVariantSelection = false;
      var selectRequiredText = '';
      if (product && product.options && product.options.length === 1) {
        requiresVariantSelection = true;
        var option = product.options[0];
        selectRequiredText = 'Select ' + option.name;
        var variants = product.variants || [];
        var selectWrapper = document.createElement('div');
        selectWrapper.className = 'wishlist-page__variants';
        var label = document.createElement('label');
        label.textContent = option.name;
        selectWrapper.appendChild(label);
        var selectWrap = document.createElement('div');
        selectWrap.className = 'wishlist-page__select-wrap';
        var select = document.createElement('select');
        select.className = 'wishlist-page__select';
        var placeholder = document.createElement('option');
        placeholder.disabled = true;
        placeholder.selected = true;
        placeholder.textContent = selectRequiredText;
        select.appendChild(placeholder);
        option.values.forEach(function (value) {
          var opt = document.createElement('option');
          opt.value = value;
          opt.textContent = value;
          select.appendChild(opt);
        });
        var display = document.createElement('div');
        display.className = 'wishlist-page__select-display';
        var displayText = document.createElement('div');
        displayText.className = 'wishlist-page__select-text';
        displayText.textContent = selectRequiredText;
        var caret = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        caret.setAttribute('viewBox', '0 0 24 24');
        caret.setAttribute('aria-hidden', 'true');
        caret.classList.add('wishlist-page__select-caret');
        var caretPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        caretPath.setAttribute('d', 'M6 9l6 6 6-6');
        caret.appendChild(caretPath);
        display.appendChild(displayText);
        display.appendChild(caret);
        select.addEventListener('change', function () {
          displayText.textContent = select.value;
          var matched = variants.find(function (v) { return v.option1 === select.value; });
          if (matched) {
            idInput.value = matched.id;
            price.textContent = (matched.price / 100).toFixed(2);
            addBtn.disabled = false;
            var btnText = addBtn.querySelector('.wishlist-page__btn-text');
            if (btnText) btnText.textContent = 'Add to Cart';
          }
        });
        selectWrap.appendChild(display);
        selectWrap.appendChild(select);
        selectWrapper.appendChild(selectWrap);
        form.appendChild(selectWrapper);
      }

      var qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      qtyInput.name = 'quantity';
      qtyInput.value = '1';
      form.appendChild(qtyInput);

      var actions = document.createElement('div');
      actions.className = 'wishlist-page__actions';
      var addBtn = document.createElement('button');
      addBtn.type = 'button';
      addBtn.className = 'wishlist-page__button wishlist-page__button--primary';
      addBtn.dataset.action = 'add-to-cart';
      addBtn.dataset.variantId = item.variantId;
      addBtn.dataset.defaultText = 'Add to Cart';
      addBtn.innerHTML =
        '<span class="wishlist-page__btn-text">Add to Cart</span>' +
        '<svg class="wishlist-page__btn-spinner" viewBox="0 0 24 24" aria-hidden="true" style="display:none;width:16px;height:16px;margin-left:8px;vertical-align:middle;"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" fill="none" stroke-linecap="round" stroke-dasharray="31.4 31.4"><animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.7s" repeatCount="indefinite"/></circle></svg>';
      // 若有变体属性需要选择，则默认禁用加购按钮
      if (requiresVariantSelection) {
        addBtn.disabled = true;
        var defaultTextNode = addBtn.querySelector('.wishlist-page__btn-text');
        if (defaultTextNode) defaultTextNode.textContent = selectRequiredText || 'Select option';
      }
      actions.appendChild(addBtn);
      form.appendChild(actions);
      card.appendChild(form);

      return card;
    }

    function setAddToCartLoadingState(button, isLoading) {
      if (!button) return;
      var textNode = button.querySelector('.wishlist-page__btn-text');
      var spinnerNode = button.querySelector('.wishlist-page__btn-spinner');
      if (isLoading) {
        button.setAttribute('aria-disabled', 'true');
        button.disabled = true;
        if (textNode) textNode.textContent = 'Adding...';
        if (spinnerNode) spinnerNode.style.display = 'inline-block';
      } else {
        button.removeAttribute('aria-disabled');
        if (textNode) textNode.textContent = button.dataset.defaultText || 'Add to Cart';
        if (spinnerNode) spinnerNode.style.display = 'none';
      }
    }

    async function addToCart(variantId, quantity, context, button) {
      if (!window.routes || !window.routes.cart_add_url || !variantId) return;
      var qty = parseInt(quantity, 10);
      if (isNaN(qty) || qty < 1) qty = 1;
      setAddToCartLoadingState(button, true);
      try {
        var cartDrawer = document.querySelector('cart-drawer');
        var cartIcon = document.querySelector('#cart-icon-bubble');

        // 与主题 product-form 一致：用 FormData + sections，确保 drawer 内容同步更新
        var formData = new FormData();
        formData.append('id', String(variantId));
        formData.append('quantity', String(qty));
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          var sectionIds = cartDrawer
            .getSectionsToRender()
            .map(function (section) {
              return section.id;
            })
            .join(',');
          formData.append('sections', sectionIds);
          formData.append('sections_url', window.location.pathname);
          if (typeof cartDrawer.setActiveElement === 'function') {
            cartDrawer.setActiveElement(document.activeElement);
          }
        }

        var response = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        });
        var data = await response.json();
        if (!response.ok || data.status) { console.error('Add to cart failed', data); return; }

        // 按后端统计口径：wishlist_added_to_cart（按日/按产品累加）
        var trackData = {
          // 用于落到产品维度（优先 product_id；拿不到也可只传 variant_id）
          product_id: context && context.productId ? String(context.productId) : null,
          variant_id: String(variantId),
          // 计数口径
          quantity: qty,
          // 可选辅助字段
          product_handle: context && context.productHandle ? context.productHandle : null,
          wishlist_count: window.Wishlist && window.Wishlist.list ? window.Wishlist.list().length : null,
          shop_domain: SHOP_DOMAIN || null,
        };

        reportShopifyEvent('wishlist_added_to_cart', trackData);

        // 不跳转：优先刷新并打开主题原生 cart-drawer
        try {
          if (cartDrawer && typeof cartDrawer.renderContents === 'function' && data && data.sections) {
            cartDrawer.renderContents(data);
          } else if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open(cartIcon || undefined);
          } else if (cartIcon) {
            // 兜底：触发购物车图标点击事件（主题会打开抽屉）
            cartIcon.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
          }
        } catch (e) {}
      } catch (e) {
        console.error('Add to cart error', e);
      } finally {
        // 无论成功/失败都恢复按钮文案；若需要选择属性的卡片，恢复为可点击状态（已选后才触发到这里）
        setAddToCartLoadingState(button, false);
      }
    }

    // 事件委托
    container.addEventListener('click', function (event) {
      var btn = event.target.closest('button[data-action]');
      if (!btn) return;
      event.preventDefault();
      var action = btn.dataset.action;
      var card = btn.closest('.wishlist-page__card');
      var variantId = btn.dataset.variantId;

      if (action === 'remove') {
        if (variantId) window.Wishlist.remove(variantId);
        render();
      } else if (action === 'add-to-cart') {
        if (!card) return;
        var idInput = card.querySelector('input[name="id"]');
        var qtyInput = card.querySelector('input[name="quantity"]');
        var currentVariantId = idInput && idInput.value ? idInput.value : variantId;
        var qty = qtyInput ? qtyInput.value : '1';
        if (!currentVariantId) return;
        // 从愿望清单数据里找出对应项，拿到 productHandle 用于埋点
        var contextItem = null;
        try {
          var list = window.Wishlist && window.Wishlist.list ? window.Wishlist.list() : [];
          contextItem = list.find(function (i) { return String(i.variantId) === String(variantId); }) || null;
        } catch (e) {}
        addToCart(currentVariantId, qty, {
          productHandle: contextItem ? contextItem.productHandle : null,
          productId: contextItem ? contextItem.productId : null,
        }, btn);
      }
    });

    initPage();
  });
})();
